import styled from 'styled-components';

export const InputTextArea = styled.textarea`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colBlack);
  padding: 8px 16px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid var(--colGray3);
  background-color: var(--colWhite);
  resize: none;
  @media screen and (min-width: 768px) {
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    padding: 14px 16px;
  }
`;
